export const environment = {
    enable_console_debug: true,
    use_mock_repository: false,
    send_new_relic: true,
    credit_card_api_url: '',
    paper_gateway_url: 'https://api.stag-v2.paper.id',
    paper_mars_api_url: 'https://mars.stag-v2.paper.id/api/v1',
};
